import React from 'react';

import { BaseModal } from '../../../../components/BaseModal';

interface ConfirmRemoveSupplierModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName: string;
  supplierName: string;
  isRemoving: boolean;
}

export const ConfirmRemoveSupplierModal: React.FC<
  ConfirmRemoveSupplierModalProps
> = ({ isOpen, onClose, onConfirm, userName, supplierName, isRemoving }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title="Remove User from Distributor"
      isDismissable={!isRemoving}
      footerContent={{
        onCancel: onClose,
        onConfirm,
        confirmText: isRemoving ? 'Removing...' : 'Remove',
        isDestructive: true,
        isLoading: isRemoving,
        isDisabled: isRemoving,
      }}
    >
      <div className="space-y-4">
        <p className="text-default-600">
          Are you sure you want to remove{' '}
          <span className="font-semibold text-default-900">
            {userName || 'the current user'}
          </span>{' '}
          from{' '}
          <span className="font-semibold text-default-900">{supplierName}</span>
          ?
        </p>
        <p className="text-small text-default-500">
          Their distributor role will be cleared and they will be removed from
          all chats associated with this distributor. This cannot be undone.
        </p>
      </div>
    </BaseModal>
  );
};
